// extracted by mini-css-extract-plugin
module.exports = {"link":"h6EbCZmV9kb1zzUhkL7i","chipWrapper":"y8ZyHWJYkpY6pqpmxUB7"};